import { component } from 'picoapp'

export default component((node, ctx) => {
    const handleize = (str) => str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

    const getCountry = async () => {
        const response = await fetch("https://get.geojs.io/v1/ip/country.json");
        const body = await response.json();

        return handleize(body.country);
    };

    const updateFlag = (country) => {
        const flagImg = document.querySelector("[data-geo-flag]");
        const flagImgSrc = flagImg.getAttribute("src");
        const flagImgSrcSplit = flagImgSrc.split("/");
        flagImgSrcSplit[flagImgSrcSplit.length - 1] = `${country}.svg`;
        flagImg.setAttribute("src", flagImgSrcSplit.join("/"));
    };

    const confirmCountrySelection = () => {
        const submitBtn = document.querySelector("[data-geo-submit]");

        submitBtn.addEventListener("click", () => {
            const countryList = document.querySelector("[data-country-list]")

            if (countryList && countryList.options) {
                const selectedOption = countryList.options[countryList.selectedIndex];

                if (selectedOption.getAttribute("data-main-country") !== null) {
                    node.classList.remove("geo--active");
                    node.classList.remove('geo--active-no-delay');
                    document.body.style.overflow = 'auto';

                    const cookieName = "geoPopup";
                    const cookieValue = "true";
                    const date = new Date();
                    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                    const expires = `; expires=${date.toUTCString()}`;
                    document.cookie = `${cookieName}=${cookieValue}${expires}; path=/`;
                }

                if (selectedOption.getAttribute("data-url") !== null) {
                    const newLocation = node.dataset.currentPageType == 'product'
                        ? selectedOption.getAttribute("data-url") + window.location.pathname.slice(1)
                        : selectedOption.getAttribute("data-url");

                    window.location.href = newLocation;
                }
            }
        });
    }

    const cancelCountrySelection = () => {
        const closeGeoPopup = document.querySelectorAll("[data-geo-close]");

        closeGeoPopup.forEach((closeBtn) => {
            closeBtn.addEventListener("click", () => {
                node.classList.remove("geo--active");
                node.classList.remove("geo--active-no-delay");
                document.body.style.overflow = "auto";

                const cookieName = "geoPopup";
                const cookieValue = "true";
                const date = new Date();
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                const expires = `; expires=${date.toString()}`;
                document.cookie = `${cookieName}=${cookieValue}${expires}; path=/`;
            });
        });
    }

    const init = async () => {
        const countryList = document.querySelector('[data-country-list]');

        countryList.addEventListener('change', () => {
            const selectedCountry = countryList.options[countryList.selectedIndex].value;
            updateFlag(selectedCountry);
        });

        const cookieName = "geoPopup";
        const cookieValue = document.cookie
            .split("; ")
            .find((row) => row.includes(cookieName));

        if (cookieValue) {
            return;
        }

        const country = await getCountry();
        let internationalFallbackIndex = -1;

        if (countryList) {
            for (let i = 0; i < countryList.options.length; i += 1) {
                if (countryList.options[i].getAttribute('data-international') !== null) {
                    internationalFallbackIndex = i;
                }

                if (countryList.options[i].value === country) {
                    countryList.selectedIndex = i;
                    updateFlag(country);

                    if (countryList.options[i].getAttribute('data-main-country') === country) {
                        node.classList.remove('geo--active');
                        document.body.style.overflow = 'auto';
                    } else {
                        node.classList.add('geo--active');
                        setTimeout(() => {
                            document.body.style.overflow = 'hidden';
                        }, 3000);
                    }

                    return;
                }
            }

            // If country is not found and there's an international fallback
            if (internationalFallbackIndex !== -1) {
                countryList.selectedIndex = internationalFallbackIndex;
                updateFlag(countryList.options[internationalFallbackIndex].value);
                node.classList.add('geo--active');
                setTimeout(() => {
                    document.body.style.overflow = 'hidden';
                }, 3000);
            }
        }
    };

    const initGeoPopup = () => {
        const toggles = document.querySelectorAll('[data-load="geo-popup"]');

        toggles.forEach((toggle) => {
            toggle.addEventListener("click", () => {
                node.classList.add("geo--active-no-delay");
                document.body.style.overflow = "hidden";
            });
        });

        confirmCountrySelection();
        cancelCountrySelection();
        init();
    }

    initGeoPopup();
});